import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, moment, ReportsService, Reports) => {
			$scope.status = STATUSES.UNLOADED;
			$scope.moment = moment;

			$scope.dataTable = null;

			$scope.data  = [];
			$scope.error = null;

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              .get()
				              .then((data) => {
					              $scope.dataTable = DataTablesService.configure({
						              id:                $scope.reportId,
						              title:             'Quarterly Check Ups Individuals Report',
						              toggleableColumns: false,
						              frozenColumns:     false,
					              }, {
						              order:             [
							              [
								              5,
								              'desc',
							              ],
						              ],
					              });

					              $scope.data  = data;
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/08545134-8A9C-48AC-852D-D6AC9BE4F4EF/index.js